import React from "react";
import { BetOffer, BettingOffer } from "@models";
import { EventType } from "@gp/models";
import classNames from "classnames";

export function EventOfferBettingType(props: {
	offer: BettingOffer | BetOffer;
	withCoefficient?: boolean;
	isPopup?: boolean;
	isPage?: boolean;
	isQuickBetPage?: boolean;
	isWidget?: boolean;
}) {
	const { offer } = props;

	const itemClasses = classNames("card--qp__item card--mpt__item", {
		"card--qp--nowrap__item card--mpt--nowrap__item": !props.isPopup,
		"slip--quick": props.isQuickBetPage || props.isWidget,
	});

	const marketClasses = classNames("card--qp__market card--mpt__market", {
		"card--qp--nowrap__market card--mpt--nowrap__market": !props.isPopup,
		"slip--quick__market": props.isWidget || props.isQuickBetPage,
		// "card--play__market--clipped": !props.isPopup && !props.isPage,
		// "": props.isPopup && !props.isPage,
		// "is-clipped u-type--sml": !props.isPopup && props.isPage,
	});

	const typeClasses = classNames("card--qp__type card--mpt__type", {
		"card--qp--nowrap__type card--mpt--nowrap__type": !props.isPopup,
	});

	const tipClasses = classNames("card--qp__tip card--mpt__tip", {
		"card--qp--nowrap__tip card--mpt--nowrap__tip": !props.isPopup,
		slip__pick__tip: props.isWidget || props.isQuickBetPage,
	});

	const oddClasses = classNames(
		"card--qp__odd card--mpt__odd",
		{
			"card--qp--nowrap__odd card--mpt--nowrap__odd": !props.isPopup,
			"slip__pick__odd quote--slip slip--quick__odd":
				props.isWidget || props.isQuickBetPage,
		},
		"quote--tny"
	);

	if (
		offer.sportData.eventType &&
		offer.sportData.eventType !== EventType.NORMAL
	) {
		return <>{offer.formattedBettingTypeTip}</>;
	}
	if (props.isPopup) {
		return (
			<>
				<div className="card--qp__track card--mpt__track" />
				<div className={marketClasses}>
					<span className={typeClasses}>
						{offer.formattedBettingType}:
					</span>
					<strong className={tipClasses}>
						{offer.formattedBettingTypeTip}
					</strong>
				</div>
				{props.withCoefficient && (
					<span className={oddClasses}>{offer.value.toFixed(2)}</span>
				)}
			</>
		);
	} else if ((props.isWidget || props.isQuickBetPage) && !props.isPopup) {
		return (
			<>
				<div className="slip__pick__type">
					{offer.formattedBettingType}:
					<strong className="slip__pick__tip">
						{offer.formattedBettingTypeTip}
					</strong>
				</div>
				{props.withCoefficient && (
					<div className="slip__pick__odd quote--slip">
						{offer.value.toFixed(2)}
					</div>
				)}
			</>
		);
	} else {
		return (
			<div className={itemClasses}>
				<div className="card--qp__track card--mpt__track" />
				<div className={marketClasses}>
					<span className={typeClasses}>
						{offer.formattedBettingType}:
					</span>
					<strong className={tipClasses}>
						{offer.formattedBettingTypeTip}
					</strong>
				</div>
				{props.withCoefficient && (
					<span className={oddClasses}>{offer.value.toFixed(2)}</span>
				)}
			</div>
		);
	}
}
